(function($){
    //init notify html
    var $notify_tmpl = $(`<div class="xo-gdpr-box">
						<div class="xo-gdpr-box__inner">
							<p class="xo-gdpr-box__text">
                                ${md_gdpr_settings.message} <a class="xo-gdpr-box__learnmore" href="#">Learn more</a>
                            </p>
                            <a class="btn btn--${md_gdpr_settings.btnStyle} ${md_gdpr_settings.btnEffect}" href="#">${md_gdpr_settings.buttonText}</a>
						</div>
					</div>`),
        skin_gdpr = {
            'bt':'xo-gdpr-box--stick xo-gdpr-box--top',
            'bb':'xo-gdpr-box--stick xo-gdpr-box--bottom',
            'ft':'xo-gdpr-box--float xo-gdpr-box--float-top',
            'fb':'xo-gdpr-box--float xo-gdpr-box--float-bottom',
            'ftl':'xo-gdpr-box--float xo-gdpr-box--top-left',
            'ftr':'xo-gdpr-box--float xo-gdpr-box--top-right',
            'fbl':'xo-gdpr-box--float xo-gdpr-box--bottom-left',
            'fbr':'xo-gdpr-box--float xo-gdpr-box--bottom-right'
        };
        
    //start render notify
    if(md_gdpr_settings.applyfor == 'all'){    
        renderNotify();
    } else {
        $.get(md_gdpr_settings.urlGetCountryCode, function (res) {
            if(res.countryCode == md_gdpr_settings.applyfor)
                renderNotify();
        });
    }
    // render notify    
    function renderNotify(){
        if(md_gdpr_settings.enableGDPR && !$.cookie('md_gdpr_' + shop_domain)){
            //render custom style & style hover
            renderCustomStyle();
            //get notify html
            $currentNotify = $notify_tmpl;
            $currentNotify.addClass(skin_gdpr[md_gdpr_settings.skin]);
            $currentNotify.css('background-color', `rgba(${ md_gdpr_settings.backgroundColor.r }, ${ md_gdpr_settings.backgroundColor.g }, ${ md_gdpr_settings.backgroundColor.b }, ${ md_gdpr_settings.backgroundColor.a })`);
            $('.xo-gdpr-box__text', $currentNotify).css('color', `rgba(${ md_gdpr_settings.textColor.r }, ${ md_gdpr_settings.textColor.g }, ${ md_gdpr_settings.textColor.b }, ${ md_gdpr_settings.textColor.a })`);            
            
            if(md_gdpr_settings.enableLink)
               $('.xo-gdpr-box__learnmore', $currentNotify).attr('href', md_gdpr_settings.policyURL).text(md_gdpr_settings.linkText).show();
            else
               $('.xo-gdpr-box__learnmore', $currentNotify).hide();
           
            // envent
            $('.btn', $currentNotify).click(function(){
                if(md_gdpr_settings.hideForDays)
                    $.cookie('md_gdpr_'+shop_domain, true, { expires: parseInt(md_gdpr_settings.hideForDays) });
                else
                    $.cookie('md_gdpr_'+shop_domain, true);
                $currentNotify.hide();
            });
            
            $('body').prepend($currentNotify);

            setTimeout(function(){
                $currentNotify.css('top','').addClass('xo-gdpr-box--active');
            }, 800);
        }
    }
    
    function renderCustomStyle(){
        //render custom css
        let customCSS = md_gdpr_settings.customCSS;
        if(md_gdpr_settings.customBtnStyle){
            customCSS += `.xo-gdpr-box .btn{
                color: rgba(${ md_gdpr_settings.btnTextColor.r }, ${ md_gdpr_settings.btnTextColor.g }, ${ md_gdpr_settings.btnTextColor.b }, ${ md_gdpr_settings.btnTextColor.a });
                background-color: rgba(${ md_gdpr_settings.btnBackground.r }, ${ md_gdpr_settings.btnBackground.g }, ${ md_gdpr_settings.btnBackground.b }, ${ md_gdpr_settings.btnBackground.a });
            }`;
            if(Object.keys(md_gdpr_settings.btnHoverTextColor).length){
                customCSS += ".xo-gdpr-box .btn:hover{color:" + `rgba(${ md_gdpr_settings.btnHoverTextColor.r }, ${ md_gdpr_settings.btnHoverTextColor.g }, ${ md_gdpr_settings.btnHoverTextColor.b }, ${ md_gdpr_settings.btnHoverTextColor.a })` + "}";
            }
            if(md_gdpr_settings.btnHoverBackground){
                if(Object.keys(md_gdpr_settings.btnHoverBackground).length){
                    customCSS += ".xo-gdpr-box .btn:hover{background-color:" + `rgba(${ md_gdpr_settings.btnHoverBackground.r }, ${ md_gdpr_settings.btnHoverBackground.g }, ${ md_gdpr_settings.btnHoverBackground.b }, ${ md_gdpr_settings.btnHoverBackground.a })` + "}";
                }
            }
        }
        if(customCSS){
            $('head').append(`<style>${customCSS}</style>`);
        }
    }    
})(jQuery);
